<script>
import '/local/templates/redesign/src/assets/scss/pages/blog.scss';
import '/local/templates/redesign/src/assets/scss/pages/press.scss';
import pressPage from '../components-manual/press/pressPage.vue';
import pressShare from '../components-manual/press/pressShare.vue';

export default {
    components: {
        pressPage,
        pressShare,
    },
};
</script>
